<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Carian Laporan Rekod Ternakan Bunting Hasil AI">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px;" :items="negeri" label="Negeri"  v-model="pencarian.lkp_negeri_id"  @input="getBandar()" />
              <z-select style="margin:5px;" :items="bandar" class="mt4" label="Daerah"  v-model="pencarian.lkp_bandar_id" />
              <w-select style="margin:5px;"
                    :items="lkp_ternakan" 
                    label="Jenis Ternakan" 
                    v-model="pencarian.lkp_ternakan_id" 
                    @input="getJurusan(pencarian.lkp_ternakan_id)"
                  />
            </w-flex>
             <w-flex class="mt3">
               <w-select style="margin:5px;"
                      :items="lkp_jurusan" 
                      label="Jurusan Ternakan"  
                      v-model="pencarian.lkp_jurusan_id" 
                    />
               <w-select style="margin:5px;"
                      :items="lkp_tujuan" 
                      label="Tujuan"  
                      v-model="pencarian.lkp_tujuan_id" 
                    />
            </w-flex>
            <w-flex class="mt3">
              <!-- <w-input class="mt4" label="Tarikh Lahir" type="date" v-model="pencarian.tarikh_lahir"/>   -->
               <w-input 
                    label="Tarikh PD Dari" 
                    type="date" 
                    v-model="pencarian.tarikh_pd_dari"
                  />
                  &nbsp;
                  <w-input 
                    label="Tarikh PD Hingga" 
                    type="date" 
                    v-model="pencarian.tarikh_pd_hingga"
                  />
            </w-flex>
          </w-form>
          <br>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN SERVICE AI'">
          <template #title>
            SENARAI LAPORAN REKOD TERNAKAN BUNTING HASIL AI
          </template>
            <w-flex justify-end class="mt2">
                <w-button bg-color="success" v-on="on" @click="createExcel()" class="mr2">
                    <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                </w-button>
            </w-flex>
            <br>
          <div class="w-table-wrap" style="max-height: 400px;">
            
            <div class="table-profil-scrol">
              <br><br>
              <table class="w-table" color="light" style="border:1px" width="100%">
                <thead>
                  <tr>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="1%" >
                        BIL
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="14%" >
                        Nama Jurupermanian Beradas
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="15%" >
                        No. Permohonan
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="15%" >
                        Tujuan Pemeriksaan
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="15%" >
                       ID Premis
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="15%" >
                        Maklumat Penternak
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="10%" >
                        Tarikh AI Terkini 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="5%" >
                        Bilangan Pemeriksaan (PD)
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="5%" >
                        Bilangan Kebuntingan (positif)
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000;" width="5%" >
                        Bilangan Kebuntingan (negatif) 
                     </th>
                  </tr>
                </thead>
                <tbody>
                    <template v-if="items.data.length == 0">
                        <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="10"> Tiada Data.</td>
                        </tr>
                    </template>
                  <template  v-for="(dt, ind) in items.data" :key="dt.id">

                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                        {{ (items.current_page - 1) * items.per_page + ind + 1 }}</td>

                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jurupermanian}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_permohonan}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tujuan}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_premis}} | {{dt.nama_premis}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_penternak}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh)}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.jumlah_pd}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.jumlah_bunting}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.jumlah_tidak_bunting}}</td>
                    
                     </tr>
                  </template>
                </tbody>
              </table>
              <br><br>

            </div>
          </div>
           <w-flex justify-end class="mt3">
                <nav class="pagination">
                  <button
                  class="pagination-btn"
                  :disabled="!items.prev_page_url"
                  @click="paginate(items.prev_page_url)"
                  >
                    Sebelumnya 
                  </button>

                  <span class="pagination-info">
                    {{ items.current_page }} dari {{ items.last_page }}
                  </span>
                 

                  <button
                  class="pagination-btn"
                  :disabled="!items.next_page_url"
                  @click="paginate(items.next_page_url)"
                  >
                    Seterusnya
                  </button>
                </nav>
              </w-flex>
        </w-card>

       <!--   <z-table title="Senarai Permohonan Baka" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
         </z-table>
 -->

      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    segmenName: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'laporan.pd'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan', route: '/laporan' },
        { label: 'REKOD TERNAKAN BUNTING HASIL AI', route: 'laporan/pd' },
      ],
      // perPage: this.$page.props.items?.per_page || 1,
      form : this.datas,
     

      pencarian: {
         lkp_negeri_id: '',
         lkp_bandar_id: '',
         lkp_jenis_baka_id: '',
         lkp_ternakan_id: '',
         lkp_jurusan_id: '',
         lkp_tujuan_id: '',
         tarikh_pd_dari: '',
         tarikh_pd_hingga: '',
      },
      premis: [],
      negeri:[],
      bandar:[],
      lkp_jurusan :[],
      lkp_ternakan : [],
      lkp_tujuan: [],
      
      
    }
  },
  methods: {
    paginate(url) {
    this.$inertia.get(url, {}, {
      preserveState: true,
      preserveScroll: true,
    });
    },
   
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

   
   getJenisBaka(){
      this.$zcomm.get(this.api_service + 'lookup/jenis_baka', {}).then(res => {
        this.lkp_jenis_baka = res
      })
    },

   getNegeri(){
        this.$zcomm.get(this.api_service + 'lookup/negeri/'+1, {}).then(res => {
          this.negeri = res

        })
      },
   getBandar(){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.pencarian.lkp_negeri_id, {}).then(res => {
          this.bandar = res
        })
      },
    getTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

    getJurusan(i){
         this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
           this.lkp_jurusan = res
         })
       },
   getTujuanPd(){
      this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
        this.lkp_tujuan = res
      })
    },


   createExcel() {
      const params = {
         lkp_negeri_id: this.pencarian.lkp_negeri_id || '',
         lkp_bandar_id: this.pencarian.lkp_bandar_id || '',
         lkp_jenis_baka_id: this.pencarian.lkp_jenis_baka_id || '',
         lkp_ternakan_id: this.pencarian.lkp_ternakan_id || '',
         lkp_jurusan_id: this.pencarian.lkp_jurusan_id || '',
         lkp_tujuan_id: this.pencarian.lkp_tujuan_id || '',
         tarikh_pd_dari: this.pencarian.tarikh_pd_dari || '',
         tarikh_pd_hingga: this.pencarian.tarikh_pd_hingga || '',
         excel: 1 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('laporan.pd') + '?' + queryString;
      window.open(url, '_blank');

    // const url = route('laporan.service.service_ai') + '?' + new URLSearchParams(params).toString();
    // window.open(url, '_blank');
   }


  },

  watch: {

  },

  mounted() {
   this.getJenisBaka();
   this.getNegeri(); 
   this.getTernakan();
   // this.getJurusan();
    this.getTujuanPd();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}
</style>
